import React, { useEffect, useRef, useState } from 'react';
// import moment from 'moment';
import '../../../assets/css/StudentShortDetails.css';
import print from '../../../assets/icons/print.svg';
import studentShortpic from '../../../assets/Images/stushortpic.png';
import std from '../../../assets/Images/unnaemmeduser.png'
import nexticon from '../../../assets/icons/icon.svg';
import { formatAdmitCardDateTime, formatDateDDMMYYYY, formatDateDDMMYYYYHHMMSS_UTC, parseBackendDateContest } from '../../../Utils/data&dateTime';
import exporticon from '../../../assets/icons/export-data.svg';
import addFingerprint from '../../../assets/icons/FingerPrint.svg';
import Notifier from '../../../Utils/notify'
import { ExceptionalApprovalModal } from '../../../Component/Modals/ExceptionalFeeDueApprovalsForActivity';
import { getData, Postdata } from '../../../API/GlobalApi';
import { WaitExceptionalApprovalModal } from '../../../Component/Modals/WaitFoeExceptionalApprovals';
import { useHasPermission } from '../../../Utils/checkPermissions';
import ConfirmationModal from '../../../Component/Modals/ConfirmationModal'
import { clearOtpState, getOtpState, saveOtpState } from '../../../Utils/storeOtpStates';
import { copyToClipboard } from '../../../Utils/copyToClipboard';
import { showAdmitCardActions } from '../../../Utils/SweetAlert';
import ReconciliationStatusCell from './components/ReconciliationStatusCell';

export default function SingleActivityDetails({ selectedDetails, activityId, getActivityDatas, currentPage, setselectedStudent, activity, handleNoDuesClick, studentInfo, isSearchMode, filterQueryString, searchValue, sortField, sortOrder, setIsSearchMode, setfilterStudent, modalOpenQueryRef, getActivityStatsCount, admitCardSocketInfo, bumpReconciliationRefreshKey, patchStudentRow }) {

    const hasPermission = useHasPermission();

    console.log("selectedDetails====>", selectedDetails)
    console.log("activity====>", activity)




    // console.log("Activit",activity)

    // true  → bypass admit card check for OTP + force confirm modal (no cancel/close)
    // false → admit card check active for OTP + normal confirm modal
    const isForceConfirmActivity = true;

    const isExamStarted =
        activity?.exam_start_date &&
        new Date(activity.exam_start_date) < new Date();

    const showInactiveButton =
        isExamStarted && selectedDetails?.activity_completed === false;


    const [fingerprints, setFingerprints] = useState([null, null, null]);
    const [showFingerprints, setShowFingerprints] = useState(false);
    const [otp, setOtp] = useState(['', '', '', '', '', '']);
    const otpInputs = useRef([]);
    const [showExceptionalModal, setShowExceptionalModal] = useState(false);
    const [showWaitModal, setShowWaitModal] = useState(false);

    const [otpSent, setOtpSent] = useState(false);
    const [enteredOTP, setEnteredOTP] = useState("");
    const [defaulterApprovalLoading, setDefaulterApprovalLoading] = useState(false);
    const [showDefaulterApprovalConfirm, setShowDefaulterApprovalConfirm] = useState(false);


    const handleExceptionalUploadSuccess = () => {
        // Called after upload succeeds
        // setShowWaitModal(true);  // open wait modal
    };

    const handleSendDefaulterApproval = async () => {
        if (!selectedDetails?.student_id) return;
        setDefaulterApprovalLoading(true);
        try {
            const res = await Postdata(`students/send-defaulter-approval-whatsapp/`, {
                student_id: selectedDetails.student_id,
                activity_id: activityId,
                doc_type: 'Defaulter Approval',
            });
            if (res?.error || res?.success === false) {
                Notifier.error(res.error || 'Failed to send approval.');
            } else {
                Notifier.success('Approval request sent successfully.');
            }
        } catch {
            Notifier.error('Failed to send approval request.');
        } finally {
            setDefaulterApprovalLoading(false);
        }
    };



    const handleOtpChange = (e, index) => {
        const value = e.target.value;

        if (!/^[0-9]?$/.test(value)) return; // allow only digits

        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        // Move to next
        if (value && index < 5) {
            otpInputs.current[index + 1].focus();
        }

        // Backspace → go back
        if (!value && index > 0) {
            otpInputs.current[index - 1].focus();
        }
    };

    // const buildQueryFromCurrentFilters = () => {
    //     const filters = modalOpenQueryRef.current?.filters || {};
    //     const params = new URLSearchParams();

    //     // 🔑 INLINE API KEY MAPPING
    //     if (filters.dueClearance)
    //         params.append("sort_type", filters.dueClearance);

    //     if (filters.status)
    //         params.append("sort_by", filters.status);

    //     if (filters.admitCardStatus)
    //         params.append("admit_card_status", filters.admitCardStatus);

    //     if (
    //         filters.admitCardAvailable !== null &&
    //         filters.admitCardAvailable !== undefined
    //     ) {
    //         params.append("admit_card_available", filters.admitCardAvailable);
    //     }

    //     if (filters.search)
    //         params.append("search", filters.search);

    //     return params.toString();
    // };
    const buildQueryFromCurrentFilters = () => {
        const filters = modalOpenQueryRef.current.filters || {};
        const query = {};

        Object.entries(filters).forEach(([key, value]) => {
            if (value !== null && value !== undefined && value !== "") {
                query[key] = value;
            }
        });

        return query;
    };


    const [verifying, setVerifying] = useState(false);

    const verifyOTP = async () => {
        const finalOTP = otp.join("");

        if (finalOTP.length !== 6) {
            Notifier.info("Please enter a valid 6-digit OTP");
            return;
        }
        const isPractical = activity?.activity_event_type?.name?.includes("Practical");
        try {
            setVerifying(true);

            const payload = {
                activity_id: activityId,
                student_id: selectedDetails.student_id,
                otp: finalOTP,
            };

            const res = await Postdata("academics/activities/verify-otp/", payload);

            if (res?.message === "OTP verified successfully") {
                Notifier.success(res?.message);
                clearOtpState(selectedDetails.student_id);

                // Only open confirmation modal if NOT Practical and not a blocked defaulter
                if (!isPractical && !defaulterBlocked) {
                    setShowConfirmModal(true);
                }
                setOtpSent(false);
                setOtp(Array(6).fill(""));

                // ----------------------------
                // Prepare query correctly
                // ----------------------------
                // console.log("modalOpenQueryRef===", modalOpenQueryRef)
                const rawQuery =
                    modalOpenQueryRef.current?.query ||
                    searchValue?.trim() ||
                    "";

                // const formattedQuery = rawQuery
                //     ? `search=${encodeURIComponent(rawQuery)}`
                //     : "";
                const formattedQuery = buildQueryFromCurrentFilters();
                // Fetch latest list
                const resData = await getActivityDatas(
                    currentPage,
                    sortField,
                    sortOrder,
                    formattedQuery,
                    true,
                    true
                );


                // Update selected student
                if (resData) {
                    const updatedList = resData.students?.results || [];
                    const updatedStudent = updatedList.find(
                        (s) => s.student_id === selectedDetails?.student_id
                    );
                    if (updatedStudent) setselectedStudent(updatedStudent);
                }

            } else {
                Notifier.error(res?.error || "OTP verification failed");
            }
        } catch (error) {
            Notifier.error("OTP verification failed");
        } finally {
            setVerifying(false);
        }
    };


    const [biometricVerified, setBiometricVerified] = useState(false);
    const [selectedStudent, setSelectedStudent] = useState(null);

    const initDevice = async () => {
        const res = await fetch("http://localhost:8367/bioenable/init", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: "{}",
        });

        const text = await res.text();   // read raw text

        console.log("INIT RAW RESPONSE:", text);

        if (!text || text.trim() === "") {
            // middleware init returns blank → treat as success
            return { ErrorCode: "0", Message: "Device initialized" };
        }

        try {
            return JSON.parse(text);
        } catch (e) {
            return { ErrorCode: "-1", Message: "Invalid JSON from init" };
        }
    };


    const captureFingerprint = () => {
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.open("POST", "http://localhost:8367/bioenable/capture", true);
            xhr.setRequestHeader("Content-Type", "application/json");

            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4 && xhr.status === 200) {
                    try {
                        const data = JSON.parse(xhr.responseText);
                        resolve(data);   // <<< RETURN CAPTURE DATA
                    } catch (err) {
                        reject(err);
                    }
                } else if (xhr.readyState === 4) {
                    reject({
                        ErrorCode: "-1",
                        ErrorDescription: xhr.responseText || "Capture error"
                    });
                }
            };

            xhr.onerror = () => {
                reject({
                    ErrorCode: "-1",
                    ErrorDescription: "Capture request failed"
                });
            };

            xhr.send(JSON.stringify({
                Quality: 60,
                TimeOut: 10,
                TemplateRequired: true,
                TemplateFormat: "ISO"   // ISO or ANSI based on server config
            }));

        });
    };


    const verifyFingerprint = async (storedIso, liveIso) => {

        if (!storedIso || !liveIso) {
            return {
                Status: false,
                ErrorCode: "-1121",
                ErrorDescription: "Empty ISO given"
            };
        }

        try {
            const res = await fetch("http://localhost:8367/bioenable/verify", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    IsoTemplate: storedIso,           // Stored ISO
                    TemplateToVerify: liveIso,        // Live scan
                }),
            });

            const text = await res.text();
            console.log("verify raw response:", text);

            if (!text || !text.trim()) {
                return { Status: false };
            }

            const parsed = JSON.parse(text);

            return {
                Status: parsed.Status === true,
                ErrorCode: parsed.ErrorCode,
                ErrorDescription: parsed.ErrorDescription,
            };

        } catch {
            return { Status: false };
        }
    };

    const submitBiometricAuth = async ({ activity_id, student_id, matched }) => {
        try {
            const res = await Postdata("academics/activities/biometric-auth/", {
                activity_id,
                student_id,
                finger_matched: matched,
            });

            if (res?.status) {
                Notifier.success("Biometric authentication updated!");
            } else {
                Notifier.error(res?.message || "Failed to update biometric auth");
            }
        } catch (err) {
            Notifier.error("Server error while updating biometric auth");
        }
    };

    const handleBiometricCheck = async () => {
        const init = await initDevice();
        if (init.ErrorCode !== "0") {
            Notifier.error(init.ErrorDescription);
            return;
        }

        const live = await captureFingerprint();
        if (live.ErrorCode !== "0") {
            Notifier.error(live.ErrorDescription);
            return;
        }

        const liveIso = (live.IsoTemplate || "").replace(/\s/g, "");
        if (!liveIso) {
            Notifier.error("Captured fingerprint template is empty.");
            return;
        }
        console.log("Live ISO length:", liveIso.length);

        const storedTemplates = [
            selectedDetails?.finger_iso_1,
            selectedDetails?.finger_iso_2,
            selectedDetails?.finger_iso_3
        ].filter(Boolean);

        let matched = false;

        for (let i = 0; i < storedTemplates.length; i++) {
            let storedIsoRaw = storedTemplates[i];
            if (!storedIsoRaw) continue;

            // Remove all whitespace, newlines, carriage returns
            const storedIsoClean = storedIsoRaw.replace(/[\s\r\n]+/g, "");
            if (!storedIsoClean) {
                console.log(`Template #${i + 1} empty after cleaning, skipping.`);
                continue;
            }

            console.log(`Stored ISO #${i + 1} length:`, storedIsoClean.length);

            const result = await verifyFingerprint(storedIsoClean, liveIso);

            if (result?.Status) {
                matched = true;
                Notifier.success(`Fingerprint matched with template #${i + 1}`);
                break;
            } else {
                console.log(`Template #${i + 1} did not match:`, result?.ErrorDescription);
            }
        }

        if (!matched) Notifier.error("Fingerprint mismatch!");
    };

    const [loading, setLoading] = useState(false);

    const sendOTP = async () => {
        try {
            if (!activityId || !selectedDetails?.student_id) {
                Notifier.error("Activity or student not selected.");
                return;
            }


            setLoading(true);
            const payload = {
                activity_id: activityId,
                student_id: selectedDetails.student_id,
            };

            const res = await Postdata('academics/activities/send-otp/', payload);
            console.log("response in otp", res);

            if (res?.mobile) {
                Notifier.info(`OTP sent to ${res.mobile}`);
                setOtpSent(true); // only set after success
                saveOtpState(selectedDetails.student_id, res.mobile);

                // If first time sending OTP
                if (!otpSent) {
                    setOtpSent(true);
                } else {
                    // Resend OTP -> just clear boxes, don't change UI block
                    setOtp(['', '', '', '', '', '']);
                }
            } else if (res?.activity_id) {
                // API validation errors
                Notifier.error(`Activity error: ${res.activity_id[0]}`);
            } else {
                // Generic fallback
                Notifier.error("Failed to send OTP.");
            }

            setTimeout(() => {
                otpInputs.current[0]?.focus(); // auto focus first box
            }, 50);
        } catch (error) {
            Notifier.error("Failed to send OTP due to network or server error.");
        } finally {
            setLoading(false); // stop loader
        }
    };

    useEffect(() => {
        if (!selectedDetails) return;

        // Reset OTP fields first
        setOtp(["", "", "", "", "", ""]);
        setEnteredOTP("");
        setFingerprints([null, null, null]);
        setShowFingerprints(false);
        setOtpSent(false);

        // Show OTP only if studentId + mobile match studentInfo
        const isValid =
            selectedDetails.student_id === studentInfo?.userId &&
            selectedDetails.mobile === studentInfo?.mobile;

        if (!isValid) return;

        // Restore previous OTP session if exists
        const session = getOtpState(selectedDetails.student_id, selectedDetails.mobile);
        if (session) {
            setOtpSent(true);
            setTimeout(() => otpInputs.current[0]?.focus(), 100);
        }
    }, [selectedDetails, studentInfo]);




    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleIssueAdmitCard = async () => {
        setIsSubmitting(true);

        try {
            const activity_id = activityId;
            const student_id = selectedDetails?.student_id;

            const url = `academics/activities/mark-complete/?activity_id=${activity_id}&student_id=${student_id}`;

            const res = await getData(url);

            if (res?.error) {
                Notifier.error(res?.error || "Something went wrong!");
                return; // Do not close modal
            }

            Notifier.success("Admit Card Issued Successfully!");

            // ----------------------------
            // Prepare correct query
            // ----------------------------
            const rawQuery =
                modalOpenQueryRef.current?.query ||
                searchValue?.trim() ||
                "";

            // // const formattedQuery = rawQuery
            //     ? `search=${encodeURIComponent(rawQuery)}`
            //     : "";
            const formattedQuery = buildQueryFromCurrentFilters();
            // Refresh list
            const resData = await getActivityDatas(
                currentPage,
                sortField,
                sortOrder,
                formattedQuery,
                true,
                true
            );
            await getActivityStatsCount();
            // Update selected student
            let updatedStudent;
            if (resData) {
                const updatedList = resData.students?.results || [];
                updatedStudent = updatedList.find(
                    (s) => s.student_id === student_id
                );
                if (updatedStudent) setselectedStudent(updatedStudent);
            }

            // Close modal
            setShowConfirmModal(false);
            const admitCardUrl =
                updatedStudent?.admit_cards_list?.[0]?.unsigned_pdf_path;
            if (admitCardUrl) {
                showAdmitCardActions({
                    admitCardUrl,
                    // onDownload: () => handleDownload(admitCardUrl, selectedDetails), // pass student info if needed
                    onPrint: () => handlePrint(admitCardUrl),
                    onShare: () => handleShare(admitCardUrl),
                });
            }

        } catch (err) {
            Notifier.error(err?.response?.data?.message || "API Error");
            // keep modal open
        } finally {
            setIsSubmitting(false);
        }
    };

    const allAuthNames = selectedDetails?.all_authentication_names || [];
    const completedAuthNames = selectedDetails?.completed_authentication_names || [];
    // const isActivityCompleted = allAuthNames.every(name => completedAuthNames.includes(name));
    // ✅ Updated for new API structure
    const isActivityCompleted = allAuthNames.every(
        name => completedAuthNames.some(c => c.name === name)
    );

    // const isActivityNotCompleted = selectedDetails?.activity_completed === false;

    const allAuthCompleted =
        selectedDetails?.completed_authentication_names?.length ===
        selectedDetails?.all_authentication_names?.length;

    const admitCard =
        selectedDetails?.admit_cards_list && selectedDetails.admit_cards_list[0];

    const admitCardUrl = admitCard?.unsigned_pdf_path;
    // Check if OTP is completed

    const totalPrechecks = selectedDetails?.total_prechecks ?? 0;
    const completedPrechecks = selectedDetails?.completed_prechecks ?? 0;

    const totalAuth = selectedDetails?.total_authentications ?? 0;
    const completedAuth = selectedDetails?.completed_authentications ?? 0;

    // Flags
    const allPrechecksCompleted = completedPrechecks === totalPrechecks;
    const allAuthenticationsCompleted = completedAuth === totalAuth;
    const hasAdmitCard = Boolean(admitCardUrl);
    // Reconciliation gate (manual sign-off) — must be open before any admit-card
    // delivery action is allowed. `can_send_admit_card` is computed by the
    // backend serializer per row.
    const reconciliationOpen = selectedDetails?.can_send_admit_card !== false;
    const reconciliationMissing =
        Array.isArray(selectedDetails?.required_report_types)
            ? selectedDetails.required_report_types.filter((rt) => {
                if (rt === 'accounts') return !selectedDetails?.accounts_report?.submitted;
                if (rt === 'library') return !selectedDetails?.library_report?.submitted;
                return false;
            })
            : [];

    const isDefaulter = selectedDetails?.is_defaulter === true;
    const defaulterApproved = selectedDetails?.defaulter_exception?.status === 'approved';
    const defaulterBlocked = isDefaulter && !defaulterApproved;

    const canShowDiv =
        admitCardUrl &&
        allPrechecksCompleted &&
        allAuthenticationsCompleted &&
        reconciliationOpen &&
        !defaulterBlocked;

    const canPrint = allPrechecksCompleted && allAuthenticationsCompleted && !defaulterBlocked;


    const getActionProps = () => {
        if (canShowDiv) {
            return {
                title: "Click to proceed",
                style: {
                    fontSize: "11px",
                    padding: "3px 20px",
                    borderRadius: "999px",
                    border: "1px solid #bbf7d0",
                    background: "#dcfce7",
                    color: "#166534",
                    cursor: "pointer",
                    opacity: 1,
                },
            };
        }

        // Disabled state
        let title = "Action disabled";

        if (defaulterBlocked) {
            title = "This student is a defaulter. Admit card actions are disabled.";
        } else if (!reconciliationOpen) {
            title = `Reports are not submitted${reconciliationMissing.length ? ` (missing: ${reconciliationMissing.join(', ')})` : ''}`;
        } else if (!allPrechecksCompleted && !allAuthenticationsCompleted) {
            title = "Prechecks and authentications pending";
        } else if (!allPrechecksCompleted) {
            title = "Prechecks not completed";
        } else if (!allAuthenticationsCompleted) {
            title = "Authentications not completed";
        }

        return {
            title,
            style: {
                fontSize: "11px",
                padding: "3px 20px",
                borderRadius: "999px",
                border: "1px solid #fecaca",
                background: "#fee2e2",
                color: "#991b1b",
                cursor: "not-allowed",
                opacity: 0.6,
            },
        };
    };

    const actionProps = getActionProps();


    const isWhatsappDelivered = admitCard?.whatsapp_message_delivered === true;


    const getAdmitCardFileName = (selectedDetails) => {
        const studentName = selectedDetails?.full_name
            ?.replace(/\s+/g, "_")
            ?.toUpperCase();

        const admitCard = selectedDetails?.admit_cards_list?.[0];

        const enrollNumber = admitCard?.enroll_number
            ?.replace(/[^\w]/g, "_");

        return `${studentName}_${enrollNumber}_ADMIT_CARD.pdf`;
    };

    const handlePrint = async () => {
        try {
            if (!selectedDetails?.activity_completed) {
                const markRes = await getData(
                    `academics/activities/mark-complete/?activity_id=${activityId}&student_id=${selectedDetails?.student_id}`
                );
                if (markRes?.error) {
                    Notifier.error(markRes?.error || "Failed to mark complete");
                    return;
                }
            }

            const response = await fetch(admitCardUrl);
            const blob = await response.blob();
            const blobUrl = URL.createObjectURL(blob);

            const printWindow = window.open(blobUrl, "_blank");
            if (!printWindow) return;
            printWindow.onload = () => {
                printWindow.focus();
                printWindow.print();
            };

            const student_id = selectedDetails?.student_id;
            const formattedQuery = buildQueryFromCurrentFilters();
            const resData = await getActivityDatas(currentPage, sortField, sortOrder, formattedQuery, true, true);
            await getActivityStatsCount();
            if (resData) {
                const updatedStudent = resData.students?.results?.find(s => s.student_id === student_id);
                if (updatedStudent) setselectedStudent(updatedStudent);
            }
        } catch (err) {
            console.error("Print failed", err);
        }
    }
    const [isSharing, setIsSharing] = useState(false);

    const handleShare = async () => {
        if (isSharing) return;
        try {
            setIsSharing(true);

            // Call mark-complete only if issue status is still pending
            if (!selectedDetails?.activity_completed) {
                const markRes = await getData(
                    `academics/activities/mark-complete/?activity_id=${activityId}&student_id=${selectedDetails?.student_id}`
                );
                if (markRes?.error) {
                    Notifier.error(markRes?.error || "Failed to mark complete");
                    return;
                }
            }

            const payload = {
                student_id: selectedDetails?.student_id,
                activity_id: activityId,
            };

            const res = await Postdata(
                "academics/activities/send-admit-card-whatsapp/",
                payload
            );

            console.log("WhatsApp share response:", res);

            // ❌ API-level error
            if (res?.error) {
                Notifier.error(res?.message || "Failed to share admit card via WhatsApp");
                return;
            }

            // ✅ Success
            Notifier.success(res?.message || "Admit card shared successfully");

            // Refresh list and update selected student
            const student_id = selectedDetails?.student_id;
            const formattedQuery = buildQueryFromCurrentFilters();
            const resData = await getActivityDatas(
                currentPage,
                sortField,
                sortOrder,
                formattedQuery,
                true,
                true
            );
            await getActivityStatsCount();
            if (resData) {
                const updatedStudent = resData.students?.results?.find(
                    (s) => s.student_id === student_id
                );
                if (updatedStudent) setselectedStudent(updatedStudent);
            }

        } catch (error) {
            console.error("Share failed:", error);

            // 🌐 Network / unexpected error
            Notifier.error(
                error?.message ||
                "Something went wrong. Please try again later."
            );
        } finally {
            setIsSharing(false); // ✅ stop loader always
        }
    };

    const handleShareLinkOnWhatsapp = async () => {


        const payload = {
            student_id: selectedDetails?.student_id,
            link_to_admit_card: `${process.env.REACT_APP_WINDOW_BASEURL2}admitcard/fee/payment`,
            // link_to_admit_card: "http://localhost:3000/admitcard/fee/payment",
            activity_id: activityId
        }
        const res = await Postdata('academics/activities/send-whatsapp-download-admit-card/', payload)

        console.log("res", res)
        if (res?.error) {
            Notifier.error(res?.error)
        }
        const rawQuery =
            modalOpenQueryRef.current?.query ||
            searchValue?.trim() ||
            "";

        const formattedQuery = buildQueryFromCurrentFilters();
        // const formattedQuery = rawQuery
        //     ? `search=${encodeURIComponent(rawQuery)}`
        //     : "";

        // Refresh list

        //    await getActivityDatas(
        //         currentPage,
        //         sortField,
        //         sortOrder,
        //         formattedQuery,
        //         true,
        //         true
        //     );
        Notifier.success(res?.message)
    }


    const admitInfo = selectedDetails?.admit_card_link_info;


    const isAdmitCardActivityCompleted = selectedDetails?.activity_completed === true;

    const canSendAdmitCardLink =
        hasPermission('can-send-admit-card-download-link');




    const hasAdmitCardLinkInfo =
        selectedDetails?.admit_card_link_info &&
        Object.keys(selectedDetails.admit_card_link_info).length > 0;

    const finalAdmitCardInfo =
        admitCardSocketInfo?.student_id === selectedDetails?.student_id
            ? admitCardSocketInfo
            : selectedDetails?.admit_card_link_info;

    const shouldShowAdmitCardInfo =
        finalAdmitCardInfo &&
        Object.keys(finalAdmitCardInfo).length > 0;

    const hasFinalAdmitCardLink =
        finalAdmitCardInfo &&
        Object.keys(finalAdmitCardInfo).length > 0;

    const isAdmitCardActivity = activity?.activity_event_type?.name?.includes("Admit Card");

    const isAccountsReportSubmitted =
        selectedDetails?.activity_completed === true ||
        selectedDetails?.accounts_report?.submitted === true;

    const canShowShareLink =
        isAdmitCardActivity &&
        canSendAdmitCardLink &&
        Array.isArray(selectedDetails?.admit_cards_list) &&
        selectedDetails.admit_cards_list.length > 0 &&
        !hasFinalAdmitCardLink &&
        !isAdmitCardActivityCompleted;







    const handlePrintPracticals = async () => {
        if (!selectedDetails) return;

        try {
            // const issuedDate = new Date();
            const issuedDate =
                parseBackendDateContest(selectedDetails.activity_completed_issued_at) || new Date();
            const formattedDate = formatAdmitCardDateTime(issuedDate);
            // const qrData = selectedDetails?.permanent_registration_number;
            const student_id = selectedDetails?.student_id;
            const qrData = JSON.stringify({
                permanent_registration_number: selectedDetails?.permanent_registration_number,
                activity_id: activityId
            });

            // ✅ Encode it for URL safety
            const encodedQrData = encodeURIComponent(qrData);

            // 🖨️ PRINT PROMISE
            const printPromise = new Promise((resolve) => {
                const printWindow = window.open("", "_blank", "width=400,height=600");
                printWindow.document.write(`
                <!DOCTYPE html>
                <html>
                <head>
                    <title>Practical Admit Card</title>
                    <style>
                        @media print {
                            @page {
                                size: 75mm auto;
                                margin: 0;
                            }
                            body {
                                margin: 0;
                                padding: 0;
                            }
                        }

                        body {
                            width: 70mm;
                            margin: 0 auto;
                            font-family: monospace;
                            font-size: 11px;
                            line-height: 1.4;
                            text-align: center;
                        }

                        .header {
                            font-size: 14px;
                            font-weight: bold;
                        }

                        .sub-header {
                            font-size: 12px;
                            margin-bottom: 6px;
                        }

                        .divider {
                            border-top: 1px dashed #000;
                            margin: 6px 0;
                        }

                        .row {
                            text-align: left;
                            margin: 4px 0;
                        }

                        .label {
                            font-weight: bold;
                        }

                        .qr img {
                            width: 120px;
                            height: 120px;
                        }

                        .footer {
                            margin-top: 6px;
                            font-size: 10px;
                        }
                    </style>
                </head>
                <body>
                    <div class="header">${activity?.activity_event_type?.name}</div>
                    <div class="sub-header">Practical Admit Card</div>
                    <div class="divider"></div>
                    <div class="qr">
                        <img src="https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodedQrData}" />
                    </div>
                    <div class="divider"></div>
                    <div class="row"><span class="label">Candidate:</span> ${selectedDetails?.full_name}</div>
                    <div class="row"><span class="label">Registration No:</span> ${selectedDetails?.permanent_registration_number}</div>
                    <div class="row"><span class="label">Subject:</span> ${activity?.practical_subject}</div>
                    <div class="row"><span class="label">Date Time:</span> ${formattedDate}</div>
                    <div class="divider"></div>
                    <div class="footer">Please carry this slip to the exam hall</div>
                    <script>
                        window.onload = function () {
                            window.print();
                            setTimeout(() => window.close(), 300);
                        };
                    </script>
                </body>
                </html>
            `);
                printWindow.document.close();
                resolve();
            });

            // ✅ Already completed → ONLY PRINT, skip API
            if (selectedDetails?.activity_completed) {
                await printPromise;
                // Notifier.success("Practical Admit Card Printed!");
                return; // 🚫 no API call
            }

            // ✅ Not completed → PRINT + API together
            const [_, res] = await Promise.all([
                printPromise,
                getData(`academics/activities/mark-complete/?activity_id=${activityId}&student_id=${selectedDetails?.student_id}`)
            ]);

            // ❌ API error
            if (res?.error) {
                Notifier.error(res?.error || "Something went wrong!");
                return;
            }

            // ✅ Refresh table data
            const formattedQuery = buildQueryFromCurrentFilters();
            const resData = await getActivityDatas(
                currentPage,
                sortField,
                sortOrder,
                formattedQuery,
                true,
                true
            );
            await getActivityStatsCount();

            // ✅ Update selected student
            if (resData) {
                const updatedList = resData.students?.results || [];
                const updatedStudent = updatedList.find((s) => s.student_id === student_id);
                if (updatedStudent) setselectedStudent(updatedStudent);
            }

            Notifier.success("Practical Admit Card Issued Successfully!");

        } catch (error) {
            console.error(error);
            Notifier.error("Failed to issue admit card");
        }
    };
    if (!selectedDetails) return null;


    return (
        <>
            <div className="row">
                <div className="col-md-12">
                    <p style={{ background: '#F9F9F9', padding: '16px', borderRadius: '8px', textAlign: 'left', fontWeight: 500, color: "#222F3E", display: 'flex', justifyContent: 'space-between' }}>Activity's SHORT DETAILS:
                    </p>
                </div>
            </div>
            {(selectedDetails?.required_report_types?.length > 0) && (
                <div className="row">
                    <div className="col-md-12" style={{ padding: '0 12px 8px' }}>
                        <ReconciliationStatusCell
                            row={selectedDetails}
                            activityId={activityId}
                            onChanged={async (reportType, reportRow) => {
                                // Immediately patch the row in formattedData so the
                                // ledger gate check sees the updated accounts_report
                                // without waiting for the full API refresh.
                                if (selectedDetails?.student_id && patchStudentRow) {
                                    const patch = {};
                                    if (reportType === 'accounts') {
                                        patch.accounts_report = reportRow || null;
                                        if (reportRow) patch.accounts_eligible_for_submit = true;
                                    } else if (reportType === 'library') {
                                        patch.library_report = reportRow || null;
                                        if (reportRow) patch.library_eligible_for_submit = true;
                                    }
                                    patchStudentRow(selectedDetails.student_id, patch);
                                }
                                bumpReconciliationRefreshKey?.();
                                try {
                                    await getActivityDatas(
                                        currentPage,
                                        sortField,
                                        sortOrder,
                                        filterQueryString,
                                        true,
                                        true
                                    );
                                    await getActivityStatsCount();
                                } catch (e) {
                                    console.error('Failed to refresh after report change', e);
                                }
                            }}
                        />
                    </div>
                </div>
            )}
            <div style={{
                flex: 1,
                overflowY: "auto",
                overflowX: "hidden",
                minHeight: 0,        // ← critical for flex scroll
                paddingBottom: "20px"
            }}>
                <div className="col-md-12 p-3 stu-pro">
                    <div className='row'>
                        <div className='col-md-5'>

                            <p className="stu-title" title='Name & ID'>
                                {selectedDetails.full_name}
                            </p>
                            <p className="sd-p"
                                style={{ cursor: 'pointer', textDecoration: 'underline' }}
                                onClick={() => copyToClipboard(selectedDetails.permanent_registration_number, "Reg No copied")}>{selectedDetails.permanent_registration_number}</p>

                        </div>
                        {activity?.activity_event_type?.name?.includes("Practical") && (<div className='col-md-7'>

                            <div className='d-flex gap-2 align-items-center'>
                                <p className='sd-p' style={{ marginTop: '0px', marginBottom: '0px' }}>Invigilated By :</p>
                                <p style={{ fontSize: '14px', textAlign: 'left' }}>{selectedDetails?.practical_info?.verified_by ?? '-'}</p>
                            </div>
                            <div className='d-flex gap-2 align-items-center mt-2'>
                                <p className='sd-p' style={{ marginTop: '0px', marginBottom: '0px' }}>Invigilation At :</p>
                                <p style={{ fontSize: '14px', textAlign: 'left' }}>{formatDateDDMMYYYYHHMMSS_UTC(selectedDetails?.practical_info?.completed_at)}</p>
                            </div>
                        </div>)}

                        {canShowShareLink && (
                            <div className='col-md-7'>
                                <p onClick={handleShareLinkOnWhatsapp} style={{ textDecoration: 'underline', cursor: 'pointer', display: 'flex', gap: '4px' }}>
                                    <svg fill="#7F56DA" viewBox="0 0 32 32" version="1.1" height="20" width="20" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0">
                                        <title>Share Admit Card Link</title></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>share</title> <path d="M0 25.472q0 2.368 1.664 4.032t4.032 1.664h18.944q2.336 0 4-1.664t1.664-4.032v-8.192l-3.776 3.168v5.024q0 0.8-0.544 1.344t-1.344 0.576h-18.944q-0.8 0-1.344-0.576t-0.544-1.344v-18.944q0-0.768 0.544-1.344t1.344-0.544h9.472v-3.776h-9.472q-2.368 0-4.032 1.664t-1.664 4v18.944zM5.696 19.808q0 2.752 1.088 5.28 0.512-2.944 2.24-5.344t4.288-3.872 5.632-1.664v5.6l11.36-9.472-11.36-9.472v5.664q-2.688 0-5.152 1.056t-4.224 2.848-2.848 4.224-1.024 5.152zM32 22.080v0 0 0z"></path> </g></svg>
                                    Share Admit Card Link</p>
                            </div>
                        )}

                        {shouldShowAdmitCardInfo && (
                            <div className="col-md-7">
                                <p style={{ color: '#6B778C', fontSize: '14px' }}>
                                    WhatsApp link has been shared
                                </p>

                                <div className="d-flex justify-content- align-items-center gap-3 mt-1">
                                    <p className="stu-title">Shared By:</p>
                                    <p style={{ color: '#6B778C', fontSize: '14px' }}>
                                        {finalAdmitCardInfo.created_by}
                                    </p>
                                </div>

                                <div className="d-flex justify-content- align-items-start gap-3 mt-1">
                                    <p className="stu-title">Shared At:</p>
                                    <p style={{ color: '#6B778C', fontSize: '14px' }}>
                                        {formatDateDDMMYYYYHHMMSS_UTC(finalAdmitCardInfo.created_at)}
                                    </p>
                                </div>
                            </div>
                        )}
                    </div>


                    {/* ---------------- A. PRE-CHECKS SECTION ---------------- */}
                    <p className="stu-title mt-4">A. Pre-checks</p>
                    <div
                        className="row mt-2"
                        style={{
                            borderRadius: "8px",
                            border: "1px dashed #7F56DA",
                            padding: "12px 10px",
                            marginBottom: "8px",
                            background: "#f9fafb"
                        }}
                    >
                        {/* Earlier versions */}
                        {/*
                        {selectedDetails?.all_precheck_names?.map((precheck) => {
                        const isCompleted = selectedDetails.completed_precheck_names?.includes(precheck);

                        // const handlePrecheckClick = (e) => {
                        //     if (!isCompleted) {
                        //         handleNoDuesClick(e, selectedDetails.student_id); // 🔥 trigger only when pending
                        //     }
                        // };

                        return (
                            <>
                                <div className="col-md-5">
                                    <p className="sd-p">{precheck}</p>
                                </div>
                                <div className="col-md-7">
                                    <div className="col-md-6">
                                        <p
                                            className="sd-p"
                                            // onClick={
                                            //     !isCompleted && !selectedDetails?.exceptional_approval
                                            //         ? handlePrecheckClick
                                            //         : undefined
                                            // }
                                            style={{
                                                fontSize: "11px",
                                                padding: "3px 7px",
                                                borderRadius: "999px",
                                                color: selectedDetails?.exceptional_approval
                                                    ? "#b45309"      // orange/warning for exceptional approval
                                                    : isCompleted
                                                        ? "#166534"  // green for completed
                                                        : "#991b1b", // red for pending
                                                border: selectedDetails?.exceptional_approval
                                                    ? "1px solid #fecaca"
                                                    : isCompleted
                                                        ? "1px solid #bbf7d0"
                                                        : "1px solid #fecaca",
                                                background: selectedDetails?.exceptional_approval
                                                    ? "#fee2e2"
                                                    : isCompleted
                                                        ? "#dcfce7"
                                                        : "#fee2e2",

                                                display: "inline-flex",
                                                alignItems: "center",
                                                gap: "4px",
                                                whiteSpace: "nowrap",
                                                width: "fit-content",
                                                cursor:
                                                    !isCompleted && !selectedDetails?.exceptional_approval
                                                        ? "pointer"
                                                        : "default",
                                            }}
                                            title={
                                                !isCompleted && !selectedDetails?.exceptional_approval
                                                    ? `View Ledger Details of ${selectedDetails?.full_name}`
                                                    : selectedDetails?.exceptional_approval
                                                        ? "Exceptional Approval"
                                                        : ""
                                            }
                                        >
                                            {selectedDetails?.exceptional_approval
                                                ? "Pending "
                                                : isCompleted
                                                    ? "Completed"
                                                    : "Pending"}
                                        </p>
                                    </div>

                                </div>

                            </>
                        );
                    })} */}


                        {/* Latest versions */}
                        {selectedDetails?.all_precheck_names?.map((precheck) => {
                            const isCompleted = selectedDetails.completed_precheck_names?.includes(precheck);

                            // const handlePrecheckClick = (e) => {
                            //     if (!isCompleted) {
                            //         handleNoDuesClick(e, selectedDetails.student_id); // 🔥 trigger only when pending
                            //     }
                            // };
                            const isFeeDue = precheck === "No Dues Clearance";

                            const isCompletedFromAPI =
                                selectedDetails?.completed_precheck_names?.includes(precheck);

                            // 🔴 FINAL completion rule
                            // Fee Due + Exceptional Approval = ALWAYS Pending
                            const isCompletedFinal = isFeeDue
                                ? !selectedDetails?.exceptional_approval && isCompletedFromAPI
                                : isCompletedFromAPI;

                            // 🟠 Exceptional pending ONLY for Fee Due
                            const isExceptionalPending =
                                isFeeDue && selectedDetails?.exceptional_approval;

                            const statusText = isCompletedFinal ? "Completed" : "Pending";
                            return (
                                <>
                                    <div className="col-md-5">
                                        <p className="sd-p">{precheck}</p>
                                    </div>
                                    <div className="col-md-7">
                                        <div className="col-md-6">
                                            {/* <p
                                            className="sd-p"
                                            // onClick={
                                            //     !isCompleted && !selectedDetails?.exceptional_approval
                                            //         ? handlePrecheckClick
                                            //         : undefined
                                            // }
                                            style={{
                                                fontSize: "11px",
                                                padding: "3px 7px",
                                                borderRadius: "999px",
                                                color: selectedDetails?.exceptional_approval
                                                    ? "#b45309"      // orange/warning for exceptional approval
                                                    : isCompleted
                                                        ? "#166534"  // green for completed
                                                        : "#991b1b", // red for pending
                                                border: selectedDetails?.exceptional_approval
                                                    ? "1px solid #fecaca"
                                                    : isCompleted
                                                        ? "1px solid #bbf7d0"
                                                        : "1px solid #fecaca",
                                                background: selectedDetails?.exceptional_approval
                                                    ? "#fee2e2"
                                                    : isCompleted
                                                        ? "#dcfce7"
                                                        : "#fee2e2",

                                                display: "inline-flex",
                                                alignItems: "center",
                                                gap: "4px",
                                                whiteSpace: "nowrap",
                                                width: "fit-content",
                                                cursor:
                                                    !isCompleted && !selectedDetails?.exceptional_approval
                                                        ? "pointer"
                                                        : "default",
                                            }}
                                            title={
                                                !isCompleted && !selectedDetails?.exceptional_approval
                                                    ? `View Ledger Details of ${selectedDetails?.full_name}`
                                                    : selectedDetails?.exceptional_approval
                                                        ? "Exceptional Approval"
                                                        : ""
                                            } >
                                            {selectedDetails?.exceptional_approval
                                                ? "Pending "
                                                : isCompleted
                                                    ? "Completed"
                                                    : "Pending"}
                                        </p> */}

                                            <p
                                                className="sd-p"
                                                style={{
                                                    fontSize: "11px",
                                                    padding: "3px 7px",
                                                    borderRadius: "999px",

                                                    color: isCompletedFinal
                                                        ? "#166534"          // green
                                                        : isExceptionalPending
                                                            ? "#991b1b"      // orange
                                                            : "#991b1b",     // red

                                                    border: isCompletedFinal
                                                        ? "1px solid #bbf7d0"
                                                        : isExceptionalPending
                                                            ? "1px solid #fecaca"
                                                            : "1px solid #fecaca",

                                                    background: isCompletedFinal
                                                        ? "#dcfce7"
                                                        : isExceptionalPending
                                                            ? "#fee2e2"
                                                            : "#fee2e2",

                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    whiteSpace: "nowrap",
                                                    width: "fit-content",
                                                }}
                                                title={
                                                    isExceptionalPending
                                                        ? "Exceptional Approval (Fee Due Pending)"
                                                        : isCompletedFinal
                                                            ? "Completed"
                                                            : `Pending ${precheck}`
                                                }
                                            >
                                                {statusText}
                                            </p>

                                        </div>
                                    </div>
                                </>
                            );
                        })}

                        <div className='row'>
                            <div className="col-md-6 d-flex justify-content-start align-items-center">
                                {(
                                    // SHOW button if:
                                    // 1. exceptional_approval is TRUE  → always show
                                    // 2. OR exceptional_approval is FALSE → only show when No Dues not completed + permission
                                    selectedDetails?.exceptional_approval ||
                                    (
                                        !selectedDetails?.completed_precheck_names?.includes("No Dues Clearance") &&
                                        hasPermission("exceptional-approval-activity-pre-checks")
                                    )
                                ) && (
                                        <span
                                            style={{
                                                display: "inline-block",
                                                marginTop: "4px",
                                                padding: "3px 8px",
                                                background: selectedDetails?.exceptional_approval ? "#166534" : "#E53935",
                                                color: "#fff",
                                                borderRadius: "6px",
                                                fontSize: "11px",
                                                fontWeight: 600,
                                                cursor: selectedDetails?.exceptional_approval ? "not-allowed" : "pointer",
                                                opacity: selectedDetails?.exceptional_approval ? 0.6 : 1
                                            }}
                                            onClick={() => {
                                                // if exceptional_approval is true → do nothing
                                                if (selectedDetails?.exceptional_approval) return;

                                                // else open modal
                                                setShowExceptionalModal(true);
                                            }}
                                        >
                                            Exceptional Approval
                                        </span>
                                    )}
                            </div>
                        </div>


                        <p className="sd-p">All mandatory pre-checks must be cleared before authentication.</p>
                    </div>

                    {/* ---------------- B. AUTHENTICATION SECTION ---------------- */}
                    <p className="stu-title mt-4">B. Authentication</p>

                    <div
                        className="row mt-2"
                        style={{
                            borderRadius: "8px",
                            border: "1px dashed #7F56DA",
                            padding: "12px 10px",
                            marginBottom: "8px",
                            background: "#f9fafb",
                        }}
                    >
                        {selectedDetails?.all_authentication_names?.map((auth) => {

                            const hasAdmitCard = !!selectedDetails?.admit_cards_list?.length;

                            // const isCompleted = selectedDetails.completed_authentication_names?.includes(auth);
                            const isCompleted = selectedDetails.completed_authentication_names?.some(
                                (c) => c.name === auth
                            );

                            // Only check FEE DUE CLEARANCE
                            // const feeDueCleared =
                            //     selectedDetails?.completed_precheck_names?.includes("No Dues Clearance") &&
                            //     selectedDetails?.completed_precheck_names?.includes("Library NOC Clearance");
                            const feeDueCleared =
                                selectedDetails?.all_precheck_names?.every(precheck =>
                                    selectedDetails?.completed_precheck_names?.includes(precheck)
                                );


                            // const isDisabled = !feeDueCleared && !selectedDetails?.exceptional_approval;


                            const isPractical = activity?.activity_event_type?.name?.includes("Practical");

                            const isDisabled =
                                (!feeDueCleared && !selectedDetails?.exceptional_approval)
                                || (!isForceConfirmActivity && !isPractical && auth === "OTP" && !hasAdmitCard);


                            // CLICK HANDLER (OTP & BIOMETRIC)
                            const handleAction = () => {
                                if (isDisabled || isCompleted) return;

                                if (auth === "OTP") {
                                    sendOTP(); // sendOTP will handle loading and otpSent internally
                                }

                                if (auth === "Biometric") {
                                    handleBiometricCheck();
                                }
                            };

                            return (
                                <>
                                    <div className="col-md-5">
                                        <p className="sd-p">{auth} </p>
                                        {selectedDetails?.mobile && auth === "OTP" && (
                                            <p className="sd-p">
                                                <strong>Contact :</strong>{" "}
                                                {
                                                    !studentInfo?.mobile                // 👉 INITIAL LOAD (no row click yet)
                                                        ? selectedDetails?.mobile
                                                        : selectedDetails?.mobile === studentInfo?.mobile  // 👉 After row click
                                                            ? selectedDetails?.mobile
                                                            : studentInfo?.mobile
                                                }
                                            </p>
                                        )
                                        }
                                    </div>

                                    <div className="col-md-7">
                                        {/* ===================== OTP HANDLING ===================== */}
                                        {auth === "OTP" && otpSent ? (
                                            <>
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        gap: "10px",
                                                        flexDirection: "column",
                                                        alignItems: "flex-start",
                                                    }}
                                                >
                                                    {loading ? (
                                                        <p>Sending OTP...</p> // Replace with spinner if you have one
                                                    ) : (
                                                        <>
                                                            {/* OTP Six Boxes */}
                                                            <div style={{ display: "flex", gap: "4px", alignItems: "center" }}>
                                                                {otp.map((digit, index) => (
                                                                    <input
                                                                        key={index}
                                                                        type="text"
                                                                        value={digit}
                                                                        maxLength={1}
                                                                        ref={(el) => (otpInputs.current[index] = el)}
                                                                        onChange={(e) => handleOtpChange(e, index)}
                                                                        onKeyDown={(e) => {
                                                                            if (e.key === "Enter") {
                                                                                const finalOTP = otp.join("");
                                                                                if (finalOTP.length === 6) {
                                                                                    verifyOTP(); // 🔥 Trigger verify when Enter pressed
                                                                                }
                                                                            }
                                                                        }}
                                                                        style={{
                                                                            width: "32px",
                                                                            height: "32px",
                                                                            textAlign: "center",
                                                                            fontSize: "12px",
                                                                            borderRadius: "6px",
                                                                            border: "1px solid #ccc",
                                                                        }}
                                                                    />
                                                                ))}
                                                            </div>

                                                            {/* Resend + Verify buttons */}
                                                            <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                                                                <button
                                                                    style={{
                                                                        padding: "6px 14px",
                                                                        fontSize: "12px",
                                                                        backgroundColor: "#f39c12",
                                                                        color: "#fff",
                                                                    }}
                                                                    onClick={sendOTP}
                                                                >
                                                                    Resend OTP
                                                                </button>

                                                                <button
                                                                    className="add-btn"
                                                                    style={{ padding: "6px 14px", fontSize: "12px" }}
                                                                    onClick={verifyOTP}
                                                                    disabled={verifying}
                                                                >
                                                                    {verifying ? <span className="spinner-border spinner-border-sm" role="status" /> : "Verify"}
                                                                </button>

                                                            </div>
                                                        </>
                                                    )}
                                                </div>
                                            </>
                                        ) : (
                                            /* ===================== DEFAULT STATUS BADGE ===================== */
                                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                {/* Show SVG only when Pending */}

                                                <p
                                                    className="sd-p"
                                                    onClick={handleAction}
                                                    style={{
                                                        fontSize: "11px",
                                                        padding: "3px 7px",
                                                        borderRadius: "999px",
                                                        border: isCompleted ? "1px solid #bbf7d0" : "1px solid #fecaca",
                                                        background: isCompleted ? "#dcfce7" : "#fee2e2",
                                                        color: isCompleted ? "#166534" : "#991b1b",
                                                        display: "inline-flex",
                                                        alignItems: "center",
                                                        gap: "4px",
                                                        whiteSpace: "nowrap",
                                                        width: "fit-content",
                                                        cursor: isDisabled ? "not-allowed" : "pointer",
                                                    }}
                                                    // title={
                                                    //     isDisabled
                                                    //         ? auth === "OTP" && !hasAdmitCard
                                                    //             ? "Admit Card mandatory for OTP authentication"
                                                    //             : "Fee Due Clearance must be completed before this step"
                                                    //         : isCompleted
                                                    //             ? `${auth} is already completed`
                                                    //             : `Click to complete ${auth}`
                                                    // }
                                                    title={
                                                        isDisabled
                                                            ? (!feeDueCleared && !selectedDetails?.exceptional_approval)
                                                                ? "Fee Due Clearance must be completed before this step"
                                                                : !isPractical && auth === "OTP" && !hasAdmitCard
                                                                    ? "Admit Card mandatory for OTP authentication"
                                                                    : "Action not available"
                                                            : isCompleted
                                                                ? `${auth} is already completed`
                                                                : `Click to complete ${auth}`
                                                    }
                                                >
                                                    {isCompleted ? "Completed" : "Pending"}
                                                </p>

                                                {!isCompleted && (
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 512 512"
                                                        width="30"
                                                        height="30"
                                                        fill="#7F56DA"
                                                        style={{
                                                            cursor: isDisabled ? 'default' : 'pointer'
                                                        }}

                                                        // onClick={() => handelSendOtp(row)}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleAction(); // optional or open OTP
                                                        }}

                                                    ><title>
                                                            {/* {
                                                    isDisabled
                                                        ? "Fee Due Clearance must be completed before this step"
                                                        : isCompleted
                                                            ? `${auth} is already completed`
                                                            : `Click to complete ${auth}`
                                                }  */}
                                                            {
                                                                isDisabled
                                                                    ? auth === "OTP" && !hasAdmitCard
                                                                        ? "Admit Card mandatory for OTP authentication"
                                                                        : "Fee Due Clearance must be completed before this step"
                                                                    : isCompleted
                                                                        ? `${auth} is already completed`
                                                                        : `Click to complete ${auth}`
                                                            }
                                                        </title>
                                                        <path d="M458.5 112H265V62.4A31.4 31.4 0 0 0 233.6 31H62.4A31.4 31.4 0 0 0 31 62.4v387.2A31.4 31.4 0 0 0 62.4 481h171.2A31.4 31.4 0 0 0 265 449.6V292h193.5A22.5 22.5 0 0 0 481 269.5V134.5A22.5 22.5 0 0 0 458.5 112ZM125.5 50.1h45a11.3 11.3 0 0 1 0 22.5h-45a11.3 11.3 0 0 1 0-22.5Zm45 411.8h-45a11.3 11.3 0 1 1 0-22.5h45a11.3 11.3 0 0 1 0 22.5Zm74.7-41.6H50.8V91.8h194.4V112H125.3a22.3 22.3 0 0 0-22.3 22.3V269.7a22.3 22.3 0 0 0 22.3 22.3H166v36.1a11.1 11.1 0 0 0 19 7.9L229 292h16.2ZM220.8 210.2a11.3 11.3 0 0 1-11.3 19.5L195.3 221.4V238a11.3 11.3 0 0 1-22.5 0v-16.6l-14.3 8.3a11.2 11.2 0 0 1-15.4-4.1 11.3 11.3 0 0 1 4.1-15.4L161.5 202l-14.3-8.3a11.3 11.3 0 0 1 11.3-19.5l14.3 8.3V166a11.3 11.3 0 0 1 22.5 0v16.5l14.3-8.3a11.3 11.3 0 0 1 11.3 19.5l-14.3 8.3ZM328.8 210.2a11.3 11.3 0 0 1-11.3 19.5l-14.3-8.3V238a11.3 11.3 0 0 1-22.5 0v-16.6l-14.3 8.3a11.2 11.2 0 0 1-15.4-4.1 11.3 11.3 0 0 1 4.1-15.4l14.3-8.3-14.3-8.3a11.3 11.3 0 0 1 11.3-19.5l14.3 8.3V166a11.3 11.3 0 0 1 22.5 0v16.5l14.3-8.3a11.3 11.3 0 0 1 11.3 19.5l-14.3 8.3ZM436.8 210.2a11.3 11.3 0 0 1-11.3 19.5l-14.3-8.3V238a11.3 11.3 0 0 1-22.5 0v-16.6l-14.3 8.3a11.2 11.2 0 0 1-15.4-4.1 11.3 11.3 0 0 1 4.1-15.4l14.3-8.3-14.3-8.3a11.3 11.3 0 0 1 11.3-19.5l14.3 8.3V166a11.3 11.3 0 0 1 22.5 0v16.5l14.3-8.3a11.3 11.3 0 0 1 11.3 19.5l-14.3 8.3Z" />
                                                    </svg>
                                                )}

                                            </div>

                                        )}
                                    </div>
                                </>
                            );
                        })}


                        <p className="sd-p mt-2">All authentication steps must be completed.</p>
                    </div>

                    {activity?.activity_event_type?.name?.includes("Admit Card") && (
                        <>
                            <p className="stu-title mt-4">C. Admit Card Details</p>

                            <div
                                className="row mt-2"
                                style={{
                                    borderRadius: "8px",
                                    border: "1px dashed #7F56DA",
                                    padding: "12px 10px",
                                    marginBottom: "8px",
                                    background: "#f9fafb",
                                }}
                            >

                                <div className="col-md-12 d-flex justify-content-between flex-row">
                                    <div className='align-self-end'> {selectedDetails?.completed_authentication_names?.includes("OTP") &&
                                        selectedDetails?.completed_precheck_names?.includes("No Dues Clearance") &&
                                        !selectedDetails?.activity_completed && selectedDetails?.activity_completed === false && (   // ⬅️ NEW CONDITION
                                            // <div className="col-md-12 d-flex justify-content-end">
                                            // <button
                                            //     className='add-btn'
                                            //     onClick={() => setShowConfirmModal(true)}
                                            // >
                                            //     Issue Admit Card
                                            // </button>




                                            <p
                                                className="sd-p"
                                                // onClick={handleShare}
                                                onClick={() => { if (!defaulterBlocked) setShowConfirmModal(true); }}
                                                title={isActivityCompleted ? "Click to Share" : "Authentication Pending"} // ✅ dynamic title
                                                style={{
                                                    fontSize: "11px",
                                                    padding: "3px 20px",
                                                    borderRadius: "999px",
                                                    border: isActivityCompleted ? "1px solid #bbf7d0" : "1px solid #fecaca",
                                                    background: isActivityCompleted ? "#dcfce7" : "#fee2e2",
                                                    color: isActivityCompleted ? "#166534" : "#991b1b",
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    gap: "4px",
                                                    whiteSpace: "nowrap",
                                                    width: "fit-content",
                                                    cursor: isActivityCompleted ? "pointer" : "not-allowed",
                                                }}

                                            >
                                                Issue Admit Card
                                            </p>
                                            // </div>
                                        )}
                                    </div>

                                    {/* {allAuthCompleted && selectedDetails?.activity_completed === true && ( */}
                                    <>
                                        {/* Admit card exists but empty */}
                                        {!hasAdmitCard && (
                                            <span className="" style={{ color: 'red' }}>
                                                Admit Card is not available
                                            </span>
                                        )}

                                        {/* Admit card found */}

                                        {hasAdmitCard && !defaulterBlocked && (<div className="d-flex gap-2 align-self-start">
                                            {/* Download */}
                                            {/* Print */}
                                            {/* <p
                                        // className="btn btn-sm btn-secondary"
                                        // style={{ padding: '10px 15px' }}
                                        onClick={handlePrint}
                                        disabled={!isActivityCompleted} // ❌ disable if activity not completed
                                        style={{
                                            fontSize: "11px",
                                            padding: "3px 7px",
                                            borderRadius: "5px",
                                            border: isActivityCompleted ? "1px solid #7F56DA" : "1px solid #fecaca",
                                            background: isActivityCompleted ? "#7F56DA" : "#fee2e2",
                                            color: isActivityCompleted ? "#fff" : "#991b1b",
                                            display: "inline-flex",
                                            alignItems: "center",
                                            gap: "4px",
                                            whiteSpace: "nowrap",
                                            width: "fit-content",
                                            cursor: isActivityCompleted ? "pointer" : "default",
                                        }}
                                    >
                                        Print
                                    </p> */}



                                            <p
                                                className="sd-p"
                                                // onClick={() => {
                                                //     if (isActivityCompleted) handlePrint();
                                                // }}
                                                onClick={() => {
                                                    if (canShowDiv) handlePrint();
                                                }}

                                                {...actionProps}

                                            >
                                                Print
                                            </p>


                                            <p
                                                className="sd-p"
                                                // onClick={handleShare}
                                                onClick={() => {
                                                    if (canShowDiv) handleShare();
                                                }}
                                                {...actionProps}

                                            >
                                                {isSharing ? (
                                                    <>
                                                        <span className="spinner-border spinner-border-sm" />
                                                        Sharing...
                                                    </>
                                                ) : (
                                                    "Share"
                                                )}
                                            </p>

                                            <p
                                                className="sd-p"
                                                {...actionProps}
                                                onClick={async () => {
                                                    if (!canShowDiv) return;
                                                    if (!selectedDetails?.activity_completed) {
                                                        const markRes = await getData(
                                                            `academics/activities/mark-complete/?activity_id=${activityId}&student_id=${selectedDetails?.student_id}`
                                                        );
                                                        if (markRes?.error) {
                                                            Notifier.error(markRes?.error || "Failed to mark complete");
                                                            return;
                                                        }
                                                        const student_id = selectedDetails?.student_id;
                                                        const formattedQuery = buildQueryFromCurrentFilters();
                                                        const resData = await getActivityDatas(currentPage, sortField, sortOrder, formattedQuery, true, true);
                                                        await getActivityStatsCount();
                                                        if (resData) {
                                                            const updatedStudent = resData.students?.results?.find(s => s.student_id === student_id);
                                                            if (updatedStudent) setselectedStudent(updatedStudent);
                                                        }
                                                    }
                                                    window.open(admitCardUrl, "_blank", "noopener,noreferrer");
                                                }}
                                                style={{ ...actionProps.style, cursor: canShowDiv ? "pointer" : "not-allowed" }}
                                            >
                                                View
                                            </p>

                                        </div>)}

                                    </>



                                    {/* )} */}
                                </div>

                                {isDefaulter && (
                                    <div style={{
                                        background: defaulterApproved ? '#F0FDF4' : '#FEF3F2',
                                        border: defaulterApproved ? '1px solid #86EFAC' : '1px solid #FDA29B',
                                        borderRadius: '8px', padding: '12px 16px',
                                        display: 'flex', flexDirection: 'column', gap: '8px',
                                        marginTop: '10px', width: '100%',
                                    }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={defaulterApproved ? '#039855' : '#D92D20'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                <circle cx="12" cy="12" r="10" />
                                                <line x1="12" y1="8" x2="12" y2="12" />
                                                <line x1="12" y1="16" x2="12.01" y2="16" />
                                            </svg>
                                            <span style={{ color: defaulterApproved ? '#039855' : '#D92D20', fontSize: '12px', fontWeight: 600 }}>
                                                {defaulterApproved ? 'Defaulter exception approved' : 'Student is in defaulter list'}
                                            </span>
                                        </div>
                                        <p style={{ color: defaulterApproved ? '#065F46' : '#B42318', fontSize: '11px', margin: 0 }}>
                                            {defaulterApproved
                                                ? `Approved by ${selectedDetails.defaulter_exception.decided_by}`
                                                : 'Admit card Print, Share and View are disabled. Send an approval request to proceed.'
                                            }
                                        </p>
                                        {!defaulterApproved && (
                                            <button
                                                onClick={() => setShowDefaulterApprovalConfirm(true)}
                                                disabled={defaulterApprovalLoading}
                                                style={{
                                                    alignSelf: 'flex-start',
                                                    background: '#D92D20', color: '#fff',
                                                    border: 'none', borderRadius: '6px',
                                                    padding: '5px 14px', fontSize: '12px',
                                                    fontWeight: 500,
                                                    cursor: defaulterApprovalLoading ? 'not-allowed' : 'pointer',
                                                    opacity: defaulterApprovalLoading ? 0.7 : 1,
                                                    display: 'flex', alignItems: 'center', gap: '6px',
                                                }}
                                            >
                                                {defaulterApprovalLoading
                                                    ? <><span className="spinner-border spinner-border-sm" role="status" /> Sending...</>
                                                    : 'Send Approval'
                                                }
                                            </button>
                                        )}
                                    </div>
                                )}

                                {isWhatsappDelivered && !defaulterBlocked && (
                                    <p
                                        className="sd-p"
                                        title="WhatsApp message delivered"
                                        style={{
                                            fontSize: "11px",
                                            // padding: "3px 20px",
                                            // borderRadius: "999px",
                                            // border: "1px solid #86efac",
                                            // background: "#dcfce7",
                                            // color: "#166534",
                                            display: "inline-flex",
                                            alignItems: "center",
                                            gap: "6px",
                                            whiteSpace: "nowrap",
                                            width: "fit-content",
                                            cursor: "default",
                                        }}
                                    >
                                        Admit Card shared on whatsapp
                                    </p>
                                )}


                                {selectedDetails?.admit_card_download_count > 0 &&
                                    selectedDetails?.completed_authentication_names?.some(auth => auth.is_online) &&
                                    (
                                        <p className="sd-p">
                                            Admit card downloaded <span style={{ color: 'green', fontWeight: 'bolder', textDecoration: 'underline', padding: '5px' }}> {selectedDetails?.admit_card_download_count}</span>
                                            times At <span style={{ color: 'green', fontWeight: '500', textDecoration: 'underline', padding: '5px' }}>{formatDateDDMMYYYYHHMMSS_UTC(selectedDetails.activity_completed_issued_at)}</span>
                                        </p>
                                    )}

                            </div>
                        </>
                    )}

                    {activity?.activity_event_type?.name?.includes("Practical") && (

                        <>
                            <p className="stu-title mt-4">C. Practicals</p>

                            <div
                                className="row mt-2"
                                style={{
                                    borderRadius: "8px",
                                    border: "1px dashed #7F56DA",
                                    padding: "12px 10px",
                                    marginBottom: "8px",
                                    background: "#f9fafb",
                                }}
                            >
                                <div className="col-md-5 d-flex gap-2">
                                    <p className="sd-p">
                                        <strong>Subject :</strong>{" "}
                                        {
                                            activity.practical_subject
                                        }
                                    </p>
                                </div>
                                <div className="col-md-7 d-flex gap-2">
                                    <p
                                        className="sd-p"
                                        onClick={canPrint ? handlePrintPracticals : undefined}
                                        style={{
                                            fontSize: "11px",
                                            padding: "3px 20px",
                                            borderRadius: "999px",
                                            border: canPrint ? "1px solid #bbf7d0" : "1px solid #fecaca",
                                            background: canPrint ? "#dcfce7" : "#fee2e2",
                                            color: canPrint ? "#166534" : "#991b1b",
                                            display: "inline-flex",
                                            alignItems: "center",
                                            gap: "4px",
                                            whiteSpace: "nowrap",
                                            width: "fit-content",
                                            cursor: canPrint ? "pointer" : "not-allowed",
                                        }}
                                        title={
                                            !allPrechecksCompleted && !allAuthenticationsCompleted
                                                ? `Prechecks  and Authentications  pending`
                                                : !allPrechecksCompleted
                                                    ? `Prechecks pending`
                                                    : !allAuthenticationsCompleted
                                                        ? `Authentications pending `
                                                        : "Click to print practical admit card"
                                        }
                                    >
                                        Print
                                    </p>

                                    {/* <p
                                    className="sd-p"
                                    onClick={canPrint ? handlePrintPracticals : undefined}
                                    style={{
                                        fontSize: "11px",
                                        padding: "3px 20px",
                                        borderRadius: "999px",
                                        border: canPrint ? "1px solid #bbf7d0" : "1px solid #fecaca",
                                        background: canPrint ? "#dcfce7" : "#fee2e2",
                                        color: canPrint ? "#166534" : "#991b1b",
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: "4px",
                                        whiteSpace: "nowrap",
                                        width: "fit-content",
                                        cursor: canPrint ? "pointer" : "not-allowed",
                                    }}
                                >
                                    Share
                                </p> */}

                                </div>

                            </div>
                        </>
                    )}


                    {/* <div className='d-flex justify-content-end'>
                    {showInactiveButton && (
                        <button
                            className="btn btn-warning"
                        // onClick={() => handleInactiveStudent(selectedDetails)}
                        >
                            Inactive Student
                        </button>
                    )}
                </div> */}
                </div>
            </div>

            <ExceptionalApprovalModal
                isOpen={showExceptionalModal}
                onClose={() => setShowExceptionalModal(false)}
                onUploadSuccess={handleExceptionalUploadSuccess}
                selectedDetails={selectedDetails}
                activityId={activityId}
            />
            <WaitExceptionalApprovalModal
                isOpen={showWaitModal}
                onClose={() => {
                    setShowWaitModal(false);
                    getActivityDatas(currentPage);
                }}
                onStatusChange={() => {
                    getActivityDatas(currentPage);
                }}
            />

            <ConfirmationModal
                isOpen={showConfirmModal}
                title={`Confirm ${activity?.activity_name} Issue`}
                message={
                    <span>
                        Are you sure you want to issue the{" "}
                        <strong style={{ color: "#7f56da" }}>
                            {activity?.activity_name}
                        </strong>{" "}
                        to{" "}
                        <strong style={{ color: "#7f56da" }}>
                            {selectedDetails?.full_name}
                        </strong>
                        ?
                    </span>
                }
                onConfirm={() => handleIssueAdmitCard()}
                onCancel={() => setShowConfirmModal(false)}
                isSubmitting={isSubmitting}
                triggerOnEnter={true}
                forceConfirm={isForceConfirmActivity}
            />

            <ConfirmationModal
                isOpen={showDefaulterApprovalConfirm}
                title="Send Approval Request"
                message={
                    <span>
                        Send a defaulter approval request for{" "}
                        <strong style={{ color: "#7f56da" }}>
                            {selectedDetails?.full_name}
                        </strong>
                        ? The approver will receive a link to review and approve.
                    </span>
                }
                onConfirm={() => {
                    setShowDefaulterApprovalConfirm(false);
                    handleSendDefaulterApproval();
                }}
                onCancel={() => setShowDefaulterApprovalConfirm(false)}
                isSubmitting={defaulterApprovalLoading}
            />

        </>
    );
}